import React, { useEffect, useState, useRef } from 'react';
import { api } from '../lib/api';
import { Bell, X, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => api.get('/notifications').then(r => setItems(r.data)).catch(()=>{});
  useEffect(() => { load(); const iv = setInterval(load, 45000); return () => clearInterval(iv); }, []);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const unread = items.filter(i => !i.read).length;

  const markAllRead = async () => {
    await api.post('/notifications/mark-read', { ids: [] });
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(!open)} data-testid="notif-bell"
              className="relative w-10 h-10 rounded-full bg-white/70 border border-white/70 grid place-items-center hover:bg-white transition-all">
        <Bell size={16} className="text-slate-700"/>
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#679286] text-white text-[10px] font-bold grid place-items-center border-2 border-white">{unread}</span>
        )}
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            className="absolute right-0 mt-2 w-96 glass-strong p-4 z-30"
            data-testid="notif-dropdown"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="font-serif text-lg">Notifications</div>
              {unread > 0 && <button onClick={markAllRead} className="text-xs text-[#679286] hover:underline">Mark all read</button>}
            </div>
            <div className="max-h-80 overflow-y-auto space-y-2">
              {items.map(n => (
                <Link to={n.link || '#'} key={n.id} onClick={() => setOpen(false)}
                      className={`block p-3 rounded-2xl border ${n.read ? 'bg-white/40 border-white/50' : 'bg-white/85 border-white/80'} hover:shadow`}>
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex-1">
                      <div className="text-sm font-medium">{n.title}</div>
                      {n.body && <div className="text-xs text-slate-500 mt-1">{n.body}</div>}
                      <div className="text-[0.65rem] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                    </div>
                    {n.link && <ExternalLink size={12} className="text-slate-400 mt-1"/>}
                  </div>
                </Link>
              ))}
              {items.length === 0 && <div className="text-center py-10 text-sm text-slate-400">You're all caught up.</div>}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
